import { yupResolver } from '@hookform/resolvers/yup';
import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import type { TFunction } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import { object, string } from 'yup';
import type { BlockDeviceFormModel } from './BlockDeviceForm.model';

export const TextMaxLength = 240;
export const TitleMaxLength = 65;

function editSchema(t: TFunction) {
  return object().shape({
    title: string()
      .required(t('error.required'))
      .min(1, t('error.minLength', { minLength: 1 }))
      .max(TitleMaxLength, t('error.maxLength', { maxLength: TitleMaxLength })),
    text: string()
      .required(t('error.required'))
      .transform((value: unknown) => {
        if (typeof value === 'string') {
          const trimmedValue = value.trim();
          return trimmedValue === '' ? undefined : trimmedValue;
        }
        return value;
      })
      .min(1, t('common:error.minLength', { minLength: 1 }))
      .max(TextMaxLength, t('common:error.maxLength', { maxLength: TextMaxLength })),
  });
}

export function useBlockDeviceForm(defaultValues: BlockDeviceFormModel) {
  const { t } = useTranslation([ALL_LNGS_NAMESPACES.COMMON, ALL_LNGS_NAMESPACES.ERROR]);
  const form = useForm<BlockDeviceFormModel>({
    defaultValues,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    resolver: yupResolver(editSchema(t)) as any,
    mode: 'onChange',
  });
  useEffect(() => {
    form.reset(defaultValues);
  }, [defaultValues, form]);
  return form;
}
